module.exports = __webpack_public_path__ + "static/img/tu15.aeabaa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tu15.png
// module id = ++/W
// module chunks = 128